import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "SellSheets",
  "use": "SellSheets-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"SellSheets\">\n  <path d=\"M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol